var map = {
	"./BOOST.svg": 2395,
	"./GRAB.svg": 2396,
	"./MBB.svg": 2397,
	"./TNG.svg": 2398,
	"./direpay.svg": 2399,
	"./doitnow.svg": 2400,
	"./duitnow.svg": 2401,
	"./fpay.svg": 2402,
	"./fpay2.svg": 2403,
	"./fpx.svg": 2404,
	"./online_banking.svg": 2405,
	"./rapidpays.svg": 2406,
	"./secret_pay.svg": 2407,
	"./secret_pay_offline.svg": 2408,
	"./secret_pay_pro.svg": 2409,
	"./secret_pay_pro_b.svg": 2410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;